import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit {
  messages:any=[]
  polling:any
  inputMessage:any=''
  image:any=''
  userData:any=JSON.parse(localStorage.getItem('logindata'))
  doctorData:any={
    rating:0
  }
  imageUrlArray:any=[]
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  constructor(private userSvc:AuthService,
    private activatedRoute:ActivatedRoute,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    if(this.activatedRoute.snapshot.params.id){
      this.listMessages()
     
      this.polling = setInterval(() => {
       this.listMessages()
      }, 2000);
     
    }
   
  }
  fileChanged(event){
    this.spinner.show()
    //console.log(event.target.files)
   // return false
    let type 
    if(event.target.files.length){
      type = event.target.files[0].name.split('.').pop();
      if(type=='pdf'){
        this.userSvc.pdfFileUpload(event.target.files[0]).subscribe(res=>{
        
          this.image = res['data']['original'] 
          this.sendMessage()
          this.spinner.hide()
          },
        error=>{
            alert('There was some error')
            this.spinner.hide()
        })
      }
      else{
    this.userSvc.fileUpload(event.target.files[0]).subscribe(res=>{
    this.image = res['data']['original'] 
    this.sendMessage()
    this.spinner.hide()
    },
  error=>{
      alert('There was some error')
      this.spinner.hide()
  })
}
  }
  }
  showPreview(image){
    this.imageUrlArray = []
    this.imageUrlArray.push(image)
    document.getElementById('orderImagesCLick').click()
      }

  listMessages(){
    this.userSvc.listMessages(this.activatedRoute.snapshot.params.id).subscribe(res=>{
      console.log(res)
      this.messages = res["data"]["message"]
      setTimeout(() => {
        this.scrollToBottom()
       
      },1000);
        this.doctorData.name = res["data"]["doctor"][0].name
        this.doctorData.profilePicture = res["data"]["doctor"][0]["profilePicture"]
        this.doctorData.uniquekey = res["data"]["doctor"][0]["uniquekey"]
        this.doctorData.rating = res["data"]["doctor"][0]["averageRatings"]
        this.doctorData.review = res["data"]["doctor"][0]["review"].length
        this.doctorData.education = res["data"]["doctor"][0]["education"].slice(0,2).join(',')
        this.doctorData.speciality = res["data"]["doctor"][0]["speciality"].slice(0,2).join(',')
  
  },error=>{

  })
  }
 
  ngOnDestroy(): void {
    clearInterval(this.polling);
  }
  sendMessage(){
    let type
    if(this.image!=''){
      type = this.image.split('.').pop();
    if(type=='pdf'){
        type= 'PDF'
    }
    else{
      type= 'IMAGE'
    }
      this.userSvc.sendMessage(this.activatedRoute.snapshot.params.id,this.image,type).subscribe(res=>{
     
        // this.messages.push(res["data"])
        this.listMessages()
        
         this.inputMessage=''
         this.image=''
         
        
       },error=>{
         console.log(error)
       })
    }
    else if(this.inputMessage!=''){
      this.userSvc.sendMessage(this.activatedRoute.snapshot.params.id,this.inputMessage,'TEXT').subscribe(res=>{
     
        // this.messages.push(res["data"])
        this.listMessages()
        
         this.inputMessage=''
         this.image=''
         
        
       },error=>{
         console.log(error)
       })
    }
    
  }
  scrollToBottom(): void {
    try {
        this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch(err) { }                 
}
  parseInt(number){
    return parseInt(number)
  }
  counter(i: number) {
    return new Array(i);
}

}
